module.exports = __webpack_public_path__ + "static/media/fagerstavapen.4d950b09.png";